export const isTrue = (x) => x === true;
